var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66331 4.7L8.33539 2.68377C8.4715 2.27543 8.85364 2 9.28407 2H14.6841C15.1145 2 15.4966 2.27543 15.6328 2.68377L16.3048 4.7H20.984C21.5363 4.7 21.984 5.14772 21.984 5.7C21.984 6.25229 21.5363 6.7 20.984 6.7H20.127L19.3931 19.1762C19.2998 20.7619 17.9867 22 16.3983 22H7.56988C5.98145 22 4.66833 20.7619 4.57506 19.1762L3.84116 6.7H3C2.44772 6.7 2 6.25229 2 5.7C2 5.14772 2.44772 4.7 3 4.7H7.66331ZM9.7715 4.7H14.1966L13.9633 4H10.0048L9.7715 4.7ZM18.1235 6.7H5.84462L6.57161 19.0587C6.6027 19.5873 7.0404 20 7.56988 20H16.3983C16.9277 20 17.3654 19.5873 17.3965 19.0587L18.1235 6.7ZM13.686 9.23762C13.7205 8.68641 14.1952 8.2675 14.7464 8.30195C15.2977 8.3364 15.7166 8.81117 15.6821 9.36238L15.2321 16.5624C15.1977 17.1136 14.7229 17.5325 14.1717 17.4981C13.6205 17.4636 13.2016 16.9888 13.236 16.4376L13.686 9.23762ZM10.7321 16.4376C10.7666 16.9888 10.3477 17.4636 9.79645 17.4981C9.24524 17.5325 8.77047 17.1136 8.73602 16.5624L8.28602 9.36238C8.25157 8.81117 8.67048 8.3364 9.22169 8.30195C9.7729 8.2675 10.2477 8.68641 10.2821 9.23762L10.7321 16.4376Z",
    fill: "#FC5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.27f6d9beaa810a6a5521b2dab5b3deba.svg";
export { ForwardRef as ReactComponent };